import React from 'react';
import { ChipTag, SelectColor, glyphs } from '@treelab/panda';
import { IStatus, StatusType } from '@treelab/common-logic';

import { Container } from './styled';

interface IProps {
  className?: string;
  items: IStatus[] | null;
}

const StatusList: React.FC<IProps> = ({ className, items }) => (
  <Container className={className}>
    {(items || []).map((item: IStatus) => (
      <ChipTag
        key={item.statusId}
        color={item.color as SelectColor}
        text={item.name}
        icon={item.type === StatusType.DONE ? glyphs.COMPLETE_WHITE : undefined}
      />
    ))}
  </Container>
);

export default StatusList;
